import { render, staticRenderFns } from "./KeyFields.vue?vue&type=template&id=0bc55c92&"
import script from "./KeyFields.vue?vue&type=script&lang=js&"
export * from "./KeyFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports